if (!customElements.get('nm-price-slider')) {
  class NmPriceSlider extends HTMLElement {
    connectedCallback() {
      this.rangeMin = this.querySelector('.nm-price-slider__range--min');
      this.rangeMax = this.querySelector('.nm-price-slider__range--max');
      this.fill = this.querySelector('.nm-price-slider__fill');
      this.minLabel = this.querySelector('.nm-price-slider__min-val');
      this.maxLabel = this.querySelector('.nm-price-slider__max-val');

      var pr = this.parentElement && this.parentElement.querySelector('price-range');
      if (!pr || !this.rangeMin || !this.rangeMax) return;

      var inputs = pr.querySelectorAll('input');
      this.minInput = inputs[0];
      this.maxInput = inputs[1];
      if (!this.minInput || !this.maxInput) return;

      this.currency = this.dataset.currency || '£';

      this.rangeMin.addEventListener('input', this.onSlide.bind(this));
      this.rangeMax.addEventListener('input', this.onSlide.bind(this));
      this.rangeMin.addEventListener('change', this.onCommit.bind(this));
      this.rangeMax.addEventListener('change', this.onCommit.bind(this));

      this.updateFill();
    }

    getValues() {
      var lo = parseInt(this.rangeMin.value, 10);
      var hi = parseInt(this.rangeMax.value, 10);
      return lo <= hi ? { min: lo, max: hi } : { min: hi, max: lo };
    }

    onSlide() {
      var v = this.getValues();
      this.updateFill();
      if (this.minLabel) this.minLabel.textContent = this.currency + v.min.toLocaleString('en-GB');
      if (this.maxLabel) this.maxLabel.textContent = this.currency + v.max.toLocaleString('en-GB') + '+';
    }

    onCommit() {
      var v = this.getValues();
      this.minInput.value = v.min;
      this.maxInput.value = v.max;
      this.minInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    updateFill() {
      var ceiling = parseInt(this.rangeMin.max, 10);
      if (!ceiling) return;
      var v = this.getValues();
      this.fill.style.left = (v.min / ceiling * 100) + '%';
      this.fill.style.right = (100 - v.max / ceiling * 100) + '%';
    }
  }
  customElements.define('nm-price-slider', NmPriceSlider);
}
